import { NavLink, Outlet } from 'react-router-dom';

const tabs = [
  { path: '/calendar', label: 'カレンダー', icon: 'calendar_month' },
  { path: '/extractions', label: '案件', icon: 'assignment' },
  { path: '/import', label: '取込', icon: 'inbox' },
  { path: '/partners', label: '取引先', icon: 'apartment' },
  { path: '/settings', label: '設定', icon: 'settings' },
];

export function Layout() {
  return (
    <div className="flex h-screen flex-col">
      {/* メインコンテンツ */}
      <main className="flex-1 overflow-y-auto pb-16">
        <Outlet />
      </main>

      {/* タブバー(下) */}
      <nav className="fixed bottom-0 left-0 right-0 border-t border-slate-200 bg-white">
        <div className="grid grid-cols-5">
          {tabs.map((tab) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2 text-[10px] transition-colors ${
                  isActive ? 'text-slate-900' : 'text-slate-500'
                }`
              }
            >
              <span
                className="material-symbols-outlined text-2xl leading-none"
                aria-hidden="true"
              >
                {tab.icon}
              </span>
              <span className="mt-0.5">{tab.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
